import {Templates} from "../interfaces/template";

export const APP_ROUTES = {
    INDEX: "/",
    FEATURES: {
        INDEX: "/vozmozhnosti",
    },
    BOT: {
        INDEX: "/vozmozhnosti/telegram-bot-dlya-avtovladeltsa",
        LEGACY: "/bot",
    },
    TOOLS: {
        INDEX: "/instrumenty",
    },
    MONEY: {
        INDEX: "/vozmozhnosti/denezhnye-rashody-na-avto",
        LEGACY: "/uchet-rashodov-na-avto",
    },
    MAINTENANCE: {
        INDEX: "/vozmozhnosti/uchet-to-avtomobilya",
        LEGACY: "/uchet-to-avtomobilya",
    },
    SERVICE_PROVIDERS: {
        INDEX: "/vozmozhnosti/servisnye-tochki-avtomobilya",
    },
    PLAN: {
        INDEX: "/vozmozhnosti/plan-to-avtomobilya",
        LEGACY: "/plan-to-avtomobilya",
    },
    FUEL: {
        INDEX: "/vozmozhnosti/zapravki-avtomobilya",
    },
    TRIP_CALCULATOR: {
        INDEX: "/instrumenty/kalkulyator-rashoda-na-poezdku",
        LEGACY: "/vozmozhnosti/kalkulyator-rashoda-na-poezdku",
    },
    ROUTE_DISTANCE: {
        INDEX: "/instrumenty/rasstoyanie-mezhdu-gorodami",
    },
    MILEAGE: {
        INDEX: "/vozmozhnosti/uchet-probega-avtomobilya",
    },
    NOTES: {
        INDEX: "/vozmozhnosti/zametki-avtovladeltsa",
    },
    DEMO: {
        INDEX: "/demo",
    },
    BLOG: {
        INDEX: "/blog",
    },
    PRIVACY: {
        INDEX: "/privacy",
    },
    AGREEMENT: {
        INDEX: "/agreement",
    },
};

export interface ContentPageRouteDefinition {
    path: string;
    templateId: number;
    pageKey: string;
}

export interface RedirectRouteDefinition {
    path: string;
    redirectTo: string;
    status?: number;
}

export interface StaticPageRouteDefinition {
    path: string;
    templateId: number;
    component: 'privacy' | 'agreement';
}

export const CONTENT_PAGE_ROUTES: ContentPageRouteDefinition[] = [
    {
        path: APP_ROUTES.INDEX,
        templateId: Templates.MAIN,
        pageKey: 'home',
    },
    {
        path: APP_ROUTES.FEATURES.INDEX,
        templateId: Templates.ABILITIES,
        pageKey: 'features',
    },
    {
        path: APP_ROUTES.TOOLS.INDEX,
        templateId: Templates.TOOLS,
        pageKey: 'tools',
    },
    {
        path: APP_ROUTES.MAINTENANCE.INDEX,
        templateId: Templates.MAINTENANCE,
        pageKey: 'maintenance',
    },
    {
        path: APP_ROUTES.SERVICE_PROVIDERS.INDEX,
        templateId: Templates.SERVICE_PROVIDERS,
        pageKey: 'serviceProviders',
    },
    {
        path: APP_ROUTES.PLAN.INDEX,
        templateId: Templates.PLAN,
        pageKey: 'plan',
    },
    {
        path: APP_ROUTES.FUEL.INDEX,
        templateId: Templates.FUEL,
        pageKey: 'fuel',
    },
    {
        path: APP_ROUTES.TRIP_CALCULATOR.INDEX,
        templateId: Templates.TRIP_CALCULATOR,
        pageKey: 'tripCalculator',
    },
    {
        path: APP_ROUTES.ROUTE_DISTANCE.INDEX,
        templateId: Templates.ROUTE_DISTANCE,
        pageKey: 'routeDistance',
    },
    {
        path: APP_ROUTES.MILEAGE.INDEX,
        templateId: Templates.MILEAGE,
        pageKey: 'mileage',
    },
    {
        path: APP_ROUTES.NOTES.INDEX,
        templateId: Templates.NOTES,
        pageKey: 'notes',
    },
    {
        path: APP_ROUTES.MONEY.INDEX,
        templateId: Templates.EXPENSES,
        pageKey: 'moneyExpenses',
    },
    {
        path: APP_ROUTES.BOT.INDEX,
        templateId: Templates.BOT,
        pageKey: 'bot',
    },
    {
        path: APP_ROUTES.DEMO.INDEX,
        templateId: Templates.DEMO,
        pageKey: 'demo',
    },
];

export const REDIRECT_ROUTES: RedirectRouteDefinition[] = [
    {
        path: APP_ROUTES.BOT.LEGACY,
        redirectTo: APP_ROUTES.BOT.INDEX,
        status: 301,
    },
    {
        path: APP_ROUTES.MONEY.LEGACY,
        redirectTo: APP_ROUTES.MONEY.INDEX,
        status: 301,
    },
    {
        path: APP_ROUTES.MAINTENANCE.LEGACY,
        redirectTo: APP_ROUTES.MAINTENANCE.INDEX,
        status: 301,
    },
    {
        path: APP_ROUTES.PLAN.LEGACY,
        redirectTo: APP_ROUTES.PLAN.INDEX,
        status: 301,
    },
    {
        path: APP_ROUTES.TRIP_CALCULATOR.LEGACY,
        redirectTo: APP_ROUTES.TRIP_CALCULATOR.INDEX,
        status: 301,
    },
];

export const STATIC_PAGE_ROUTES: StaticPageRouteDefinition[] = [
    {
        path: APP_ROUTES.PRIVACY.INDEX,
        templateId: Templates.PRIVACY,
        component: 'privacy',
    },
    {
        path: APP_ROUTES.AGREEMENT.INDEX,
        templateId: Templates.AGREEMENT,
        component: 'agreement',
    },
];

export function toAngularPath(path: string): string {
    if (path === APP_ROUTES.INDEX) {
        return '';
    }

    return path.replace(/^\//, '');
}

export interface ServerRouteDefinition {
    path: string;
    status?: number;
}

export function getServerRouteDefinitions(): ServerRouteDefinition[] {
    return [
        ...CONTENT_PAGE_ROUTES.map((route) => ({
            path: toAngularPath(route.path),
        })),
        ...REDIRECT_ROUTES.map((route) => ({
            path: toAngularPath(route.path),
            status: route.status,
        })),
        ...STATIC_PAGE_ROUTES.map((route) => ({
            path: toAngularPath(route.path),
        })),
    ];
}
